/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 12:40:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-01 15:58:07
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/CollapseErrors/index.tsx
 */

import React from 'react';

import css from './css.less';

import { useDispatch, useSelector } from 'react-redux';

import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

import { validation } from 'src/pages/SalesChannelContentEditor/Components/tools';

const CollapseErr = (props) => {
  const {
    getErrorDisplay,
    getContent,
    draggableId,
    onErrorChange,
    // isOpen,
    //open,
  } = props;
  const _d = useDispatch();
  const {
    //display: _display,
    hasError,
  } = useSelector(getErrorDisplay(draggableId));
  const { staticData = {}, dynamicData = [] } = useSelector(
    getContent(draggableId),
  );
  const { hasError: _err } = validation({ staticData, dynamicData });

  React.useEffect(() => {
    if (!hasError && _err) {
      _d(onErrorChange({ id: draggableId, status: true }));
    }
    if (hasError && !_err) {
      _d(onErrorChange({ id: draggableId, status: false }));
    }
  }, [_err]);
  return null;

  // return _display ? <ErrorDisplay err={_err} open={open} /> : null;
};
export default CollapseErr;

const _Container = (props) => {
  const { open, children } = props;
  const _className = React.useMemo(() => {
    return open ? css.open : css.close;
  }, [open]);
  return <div className={_className}>{children}</div>;
};

export const ErrorDisplay = (props) => {
  const { err = [], open } = props;

  return err.length > 0 ? (
    <_Container open={open}>
      <div className={css.errContainer}>
        {err.map((i, index) => {
          return (
            <div className={css.errText} key={index}>
              <NoWrapContainer>
                <GlobalTooltip title={i}>{i}</GlobalTooltip>
              </NoWrapContainer>
            </div>
          );
        })}
      </div>
    </_Container>
  ) : null;
};

export const ErrorDisplay2 = (props) => {
  const { err = [], open = true, hasError } = props;
  return hasError && err.length > 0 ? (
    <_Container open={open}>
      <div className={css.errContainer}>
        {err.map((i, index) => {
          return (
            <div className={css.errText} key={index}>
              <NoWrapContainer>
                <GlobalTooltip title={i}>{i}</GlobalTooltip>
              </NoWrapContainer>
            </div>
          );
        })}
      </div>
    </_Container>
  ) : null;
};
